module.exports = __webpack_public_path__ + "img/winerack36.e722f94f.jpg";